module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters-common"
  }, _vm._l((_vm.sortedData), function(value) {
    return (value.options.length > 0) ? _c('filter-common', {
      key: value.id,
      attrs: {
        "data": value.label,
        "options": value.options,
        "onChange": value.onChange,
        "disabled": value.disabled,
        "quantity": _vm.quantity,
        "hasGroups": value.hasGroups
      }
    }) : _vm._e()
  }), 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f46bd904", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f46bd904"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/dashboard/filter/filtersCommon.pug
// module id = 1470
// module chunks = 0